import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { sortByCountId } from '../../../utils/manual-verification-session/filter-requests';

interface NetworkStore {
  networkRequests: [];
  pagesVisted: string[];
}

const initialState: NetworkStore = {
  networkRequests: [],
  pagesVisted: [],
};

const networkStoreSlice = createSlice({
  name: 'networkRequestStore',
  initialState,
  reducers: {
    updatePagesVisted(state, action: PayloadAction<string>) {
      state.pagesVisted = [...state.pagesVisted, action.payload];
    },
    updateNetworkStore(state, action: PayloadAction<any>) {
      // @ts-ignore
      const sortedNetworkrequest = sortByCountId([
        ...state.networkRequests,
        action.payload,
      ]);
      state.networkRequests = sortedNetworkrequest;
    },
    resetNetworkStore() {
      return { ...initialState };
    },
  },
});

export const { updatePagesVisted, updateNetworkStore, resetNetworkStore } =
  networkStoreSlice.actions;

export default networkStoreSlice.reducer;
